import React from 'react';
import { AwardIcon, BookOpenIcon, StethoscopeIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { KARITO_IMAGE } from '../../data/content';
const credentials = [{
  icon: StethoscopeIcon,
  title: 'Clinical practice',
  body: 'Years of consultation experience in male hormonal health and TRT evaluation.'
}, {
  icon: BookOpenIcon,
  title: 'Evidence-based method',
  body: 'Recognized clinical guidelines and published literature organized into usable pathways.'
}, {
  icon: AwardIcon,
  title: 'Built for real consultations',
  body: 'Every protocol was designed to be opened during a busy clinic day, not after it.'
}];
export function AboutKarito() {
  return <section className="bg-paper-50 px-5 py-14 sm:px-8 sm:py-20" data-id="element-64" data-mp="2zatokpd2klee">
      <div className="mx-auto max-w-5xl" data-id="element-65" data-mp="3e69pnec2hhka">
        <div className="grid items-start gap-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-12" data-id="element-66" data-mp="3e7b31pgk2g56">
          <div className="mx-auto w-full max-w-xs lg:max-w-none" data-id="element-67" data-mp="399j62h1203u4">
            <img src={KARITO_IMAGE} alt="Dr. Karito, physician and author of the Master System of TRT" className="w-full rounded-3xl border border-paper-200 object-cover shadow-[0_20px_40px_-24px_rgba(4,18,27,0.5)]" width={928} height={1160} data-id="element-68" data-mp="7f25mk432eht" />
          </div>

          <div data-id="element-69" data-mp="lbfbevz98rgg">
            <p className="font-display text-xs font-bold uppercase tracking-[0.24em] text-teal-600" data-id="element-70" data-mp="qcwe8x1aunzo">
              About the author
            </p>
            <h2 className="mt-3 font-display text-[28px] font-bold uppercase leading-[1.05] tracking-tight text-ink-900 sm:text-4xl" data-id="element-71" data-mp="vaoce8sjf6cb">
              About Dr. Karito
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-ink-600 sm:text-lg" data-id="element-72" data-mp="14384sri8keop">
              Dr. Karito created the Master System of TRT™ out of the same frustration most
              clinicians know well: the information exists, but it lives scattered across
              guidelines, papers, and personal notes — never in the place you need it, at the moment
              you need it.
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-ink-600 sm:text-base" data-id="element-73" data-mp="357ttztsja1b3">
              So she rebuilt it as a workflow. Diagnosis, hormone interpretation, treatment
              selection, fertility, complex patients, and long-term monitoring — organized into six
              volumes, structured protocols, and visual decision algorithms you can consult in the
              middle of a consultation.
            </p>

            <ul className="mt-6 space-y-3" data-id="element-74" data-mp="3owku3xq3q9yc">
              {credentials.map(item => <li key={item.title} className="flex gap-3 rounded-2xl border border-paper-200 bg-white p-4" data-id="element-75" data-mp="6o3o7974dwsl">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-teal-50" data-id="element-76" data-mp="28hb2qgewsadf">
                    <item.icon className="h-5 w-5 text-teal-600" aria-hidden="true" data-id="element-77" data-mp="23igl3hsogruw" />
                  </span>
                  <div className="min-w-0" data-id="element-78" data-mp="izmj869pk9e4">
                    <p className="text-[15px] font-extrabold leading-snug text-ink-900" data-id="element-79" data-mp="nxxumlfniryg">
                      {item.title}
                    </p>
                    <p className="mt-1 text-sm leading-relaxed text-ink-600" data-id="element-80" data-mp="98ryx7g0vjvb">{item.body}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-81" data-mp="71w75gowyi8">
          <CtaButton label="Get Dr. Karito’s TRT System" subLabel="6 Volumes · 5 Bonuses · USD 27" data-id="element-82" data-mp="57g6ku5rkkjf" />
        </div>
      </div>
    </section>;
}